import { purchaseHistoryService } from '../services'

export default (fromNum, resultsPerPage, type, filters) => {
	return new Promise(async (resolve, reject) => {
		await purchaseHistoryService.getSolicitudes(fromNum, resultsPerPage, type, filters)
			.then(response => resolve(response))
			.catch(err => reject({error: true}))
	})
}
